<script setup>
import "@/assets/main.css";
</script>
<template>
  <div class="relative w-full flex flex-col pt-16 pb-3">
    <div class="main-content relative z-20 grid grid-rows-4 h-fit mx-7">
      <div class="magatraDigital flex flex-col text-center justify-center text-off-white">
        <h5 class="font-rougeScript text-4xl">Magatra</h5>
        <p class="my-1">Digital Invitation © 2025</p>
        <div class="mediaSosial flex flex-row justify-center">
          <a href="https://wa.me/+6285161615628"><i class="fa fa-whatsapp mx-2" target="_blank" rel="noopener"
              aria-hidden="true"></i></a>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.main-content {
  grid-template-rows: 4fr 1fr;
}
</style>
